import { gql } from '@apollo/client'

const SCHEDULED_ACTION_FRAGMENT = gql`
  fragment ScheduledActionFields on EventScheduledAction {
    id
    execute_at
    
    type {
      id
      code
      name
    },
    
    status {
      id
      code
      name
    }
  }
`

export default SCHEDULED_ACTION_FRAGMENT